// extracted by mini-css-extract-plugin
export default {"fileContainer":"Download_fileContainer__50dKG"};